import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import {
  chatContainerStyle,
  // chatContentStyle,
  chatbotContentStyleMobile,
  chatbotAvatarStyle,
  chatbotAvatarStyleMobile,
  chatbotBubbleStyle,
  chatbotFooterStyle,
  chatbotBubbleStyleMobile,
  helloAvaTheme
} from "../../utils/styles";
import * as util from "../../utils/util";
import * as aaUtil from "../utils/aaUtils";

import { ChatContainer } from "../utils/styles";

import "../../views/onboarding/Onboarding.css";

class AthOnboarding extends Component {
  constructor(props) {
    super(props);

    this.handleEnd = this.handleEnd.bind(this);

    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      },
      startBoarding: localStorage.getItem("ath_user_id") ? false : true,
      chatbotStyle: {
        width: "100%",
        maxWidth: "1360px",
        //maxHeight: '100%',
        height: "100%",
        //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
        //height: this.state.viewport.height - 20,
        background: "#fff",
        overflow: "hidden",
        display: "none"
      },
      chatbotStyleMobile: {
        width: "100%",
        maxWidth: "996px",
        //maxHeight: '100%',
        height: "95%",
        //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
        //height: this.state.viewport.height - 20,
        background: "#fff",
        overflow: "hidden",
        overflowY: "scroll",
        display: "none"
      }
    };
  }

  fun_startBoarding = () => {
    aaUtil.event24_view_question("Intro/privacy question", "Consent Yes", "Q0");
    let chatbotStyleData = Object.assign({}, this.state.chatbotStyle, {
      display: "block"
    });
    let chatbotStyleMobileData = Object.assign(
      {},
      this.state.chatbotStyleMobileData,
      { display: "block" }
    );
    this.setState({
      startBoarding: false,
      chatbotStyle: chatbotStyleData,
      chatbotStyleMobile: chatbotStyleMobileData
    });
  };

  fun_endBoarding = () => {
    aaUtil.event24_view_question("Intro/privacy question", "Consent No", "Q0");
    setTimeout(() => {
      window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
    }, 500);
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleMediaQueries.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleMediaQueries.bind(this));
  }

  handleMediaQueries() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    });
  }

  handleEnd({ steps }) {
    let requestBody = {};

    if(!steps){
      window.location.reload();
      return;
    }

    if (steps["Q0-1"]) {
      setTimeout(() => {
        window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
      }, 500);
      return;
    }

    //Redirect to buffer page if user says No on quiz retake
    if (steps["Q2-1"]) {
      setTimeout(() => {
        this.props.history.push("/ath/profile");
      }, 500);
      return;
    }

    // The request must contain the 15 survey answers
    if (steps["A4"]) {
      requestBody = {
        Concern: steps["A4"].value.split(":")[0],
        Shape: steps["A4-2"].value,
        Texture: steps["A5"].value,
        Volume: steps["A5-2"].value,
        Dandruff: steps["A6"].value,
        Condition1: steps["A7"].value,
        Condition2: steps["A8"].value,
        Treatment1: steps["A8-1"].value,

        Styling1: steps["A8-3"].value.split(":")[0],
        Styling2: steps["A8-4"].value,
        Styling3: steps["A8-5"].value.split(":")[0],
        Routine: "wash,condition,dry,style,refresh",
        RoutineIdx: "3",
        SelfieIdx: parseInt(steps["A8-6"].value, 10)
      };
    }

    // The request may have a user id if user signin
    if (localStorage.getItem("ath_user_id")) {
      requestBody["userId"] = localStorage.getItem("ath_user_id");
    }

    if (steps["A8-2"]) {
      requestBody["Treatment2"] = steps["A8-2"].value;
    } else {
      requestBody["Treatment2"] = "4";
    }
    // The request may have user selfie if user uploads
    if (steps["A8-6A"]) {
      requestBody["selfie"] = steps["A8-6A"].value;
    }

    // The request may have user profile info if user has not signin
    if (!localStorage.getItem("ath_auth_token")) {
      requestBody["firstName"] = steps["A1-1"].value.split(":")[0];
      requestBody["lastName"] = steps["A1-1"].value.split(":")[1];
      requestBody["age"] = steps["A2"].value;
      // requestBody["ethnicity"] = steps["A3"].value;
      requestBody["gender"] = steps["A3-A"].value;
      if (!localStorage.getItem("ath_user_id")) {
        requestBody["email"] = steps["A9"].value.split(":")[0];
        requestBody["phoneNumber"] = steps["A9"].value.split(":")[1];
        requestBody["password"] = steps["A9"].value.split(":")[2];
        requestBody["optIn"] = steps["A9"].value.split(":")[3] === "true";
      }
    }
   
    if(steps["A9"]){
      if ((requestBody["optIn"] = steps["A9"].value.split(":")[3] === "true")) {
        aaUtil.event50_opt_in_event("Phase 1");
      }
    }

    if (util.isMobile(navigator.userAgent)) {
      requestBody["signupSource"] = "mobile";
    }

    // Redirect to home if user says 'No' to region question.https://helloavadev.atlassian.net/browse/HD-357

    if (Object.keys(requestBody).length > 0) {
      fetch("/api/ath-hair-profiles", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          if (localStorage.getItem("ath_auth_token")) {
            this.props.history.push({
              pathname: "/ath/profile"
            });
            // return;
          } else {
            return response.json();
          }
        })
        .then(json => {
          // If this is a new user, we need to save the token and user id
          if (json.token) {
            const firstName = requestBody["firstName"];
            const lastName = requestBody["lastName"];
            const phoneNumber = requestBody["phoneNumber"];
            const email = requestBody["email"];

            localStorage.setItem("ath_auth_token", json.token.token);
            localStorage.setItem("ath_user_id", json.userId);
            localStorage.setItem("ath_user_firstname", firstName);
            localStorage.setItem("ath_user_lastname", lastName);
            localStorage.setItem("ath_phone_number", phoneNumber);
            localStorage.setItem("ath_email", email);
            localStorage.setItem("temp_new_user_flag", true);
          }

          aaUtil.event27_submit_quiz();
          window.location.href = "/ath/profile";
        })
        .catch(error => {
          console.log(error);
          // alert("There is a problem to save the survey. Please try again. " + error );
        });
    }
  }

  render() {
    const chatbotStyle = {
      // width: "100%",
      // maxWidth: "1360px",
      // //maxHeight: '100%',
      // height: "100%",
      // //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
      // //height: this.state.viewport.height - 20,
      // background: "#fff",
      // overflow: "hidden"
    };

    // render() {
    let touchsupport =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    const chatContentStyle = {
      height: "87%",
      overflowX: "hidden",
      padding: "0",
      margin: "0"
      // marginTop: "10px"
    };

    const chatContentStyleMobile = {
      height: "100%",
      overflowX: "hidden",
      padding: "0",
      margin: "0"
      // marginTop: "10px"
    };

    return (
      <ChatContainer style={
        this.state.startBoarding
          ? { height: '99%' }
          : { height: '89%' }
      }>
        {this.state.startBoarding ? (
          <div className="rectangle-area">
            <div
              className="rectangle"
              style={
                this.state.startBoarding
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <span className="close" onClick={this.fun_endBoarding}></span>
              <div className="font-style">
                Before we start, we need your permission to share your
                <div className="wordwrap"></div>
                information with our trusted technology partner, HelloAva.
              </div>
              <div className="font-style margint-2">
                Don<span className="font-symbol">’</span>t worry, your data is
                kept strictly confidential and will not be{" "}
                <div className="wordwrap"></div> shared with any third party
                companies. Are you happy to proceed?
                <div className="wordwrap"></div>
                (For more information, please refer to their
                <div className="wordwrap"></div>
                <a
                  target="_blank"
                  className="onboarding-privacy-link"
                  href="/privacy"
                >
                  Privacy Policy
                </a>
                ).
              </div>
              <div className="margint-2">
                <div className="rsc-os sc-EHOje edRFCv">
                  <ul className="padding-0 sc-ifAKCX gkhNlr">
                    <li onClick={this.fun_startBoarding} className="button-1">
                      <a>Yes, I understand</a>
                    </li>
                    <li onClick={this.fun_endBoarding} className="button-2">
                      <a className="rsc-os-option-element sc-bxivhb ikiskt">
                        I don’t want to continue
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="v-modal"></div>
          </div>
        ) : (
          <ThemeProvider theme={helloAvaTheme}>
            <ChatBot
              className={!touchsupport ? "nontouch" : ""}
              hideHeader={true}
              hideUserAvatar={true}
              botAvatar="/images/onboarding/ava-chat.svg"
              steps={this.props.steps}
              handleEnd={this.handleEnd}
              // style={
              //   this.state.viewport.width <= 900
              //     ? this.state.chatbotStyleMobile
              //     : this.state.chatbotStyle
              // }
              style={chatbotStyle}
              contentStyle={
                this.state.viewport.width <= 900
                  ? chatContentStyleMobile
                  : chatContentStyle
              }
              avatarStyle={
                this.state.viewport.width <= 900
                  ? chatbotAvatarStyleMobile
                  : chatbotAvatarStyle
              }
              bubbleStyle={
                this.state.viewport.width <= 900
                  ? chatbotBubbleStyleMobile
                  : chatbotBubbleStyle
              }
              footerStyle={
                chatbotFooterStyle
              } /*enableSmoothScroll={ true } enableMobileAutoFocus={ true }*/
            />
          </ThemeProvider>
        )}
      </ChatContainer>
    );
  }
}

export default withRouter(AthOnboarding);



// WEBPACK FOOTER //
// ./src/ath/views/AthOnboarding.js